<template>
  <div
    v-if="isShowConditionPanel"
    class="condition-panel__condition">
    <slot name="header" />
    <div
      v-if="conditions.length > 0"
      class="conditions mb-3">
      <div
        v-for="condition in conditions"
        :key="condition.name"
        class="condition">
        <div class="name">
          {{ condition.name }}
        </div>
        <div class="value">
          {{ condition.value }}
        </div>
      </div>
    </div>
    <div v-if="isShowBodyPain">
      <BodyPainPanel
        v-if="isShowAllBodyPainItems"
        :activity="activity"
        :body-pain-setting="bodyPainSetting" />
      <BodyPainPanelOnlyDetail
        v-else
        :activity="activity"
        :body-pain-setting="bodyPainSetting" />
    </div>
  </div>
</template>

<script>
import BodyPainPanel from '@/components/parts/BodyPainPanel.vue'
import BodyPainPanelOnlyDetail from '@/components/parts/BodyPainPanelOnlyDetail.vue'
import { conditionValues, getConditionValueWithUnit, labelByConditionValue } from '@/helper/conditions'
export default {
  components: {
    BodyPainPanel,
    BodyPainPanelOnlyDetail
  },
  props: {
    activity: {
      type: Object,
      required: true
    },
    isShowAllBodyPainItems: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    conditions() {
      if (this.conditionSetting === null || this.activity.condition === null) return []
      return conditionValues.reduce((acc, value) => {
        if (this.conditionSetting.items.includes(value)) {
          acc.push({
            name: labelByConditionValue[value],
            value: getConditionValueWithUnit(value, this.activity.condition[value])
          })
        }
        return acc
      }, [])
    },
    conditionSetting() {
      return this.activity.conditionSetting
    },
    bodyPainSetting() {
      return this.activity.bodyPainSetting
    },
    isShowBodyPain() {
      if (this.bodyPainSetting === null) return false
      return this.bodyPainSetting.isRecordBodyPain
    },
    hasCondition() {
      return !(this.conditionSetting === null || this.activity.condition === null)
    },
    hasBodyPain() {
      return this.bodyPainSetting?.isRecordBodyPain !== null || this.activity.bodyPain !== null
    },
    isShowConditionPanel() {
      return this.hasCondition || this.hasBodyPain
    }
  },
}
</script>

<style lang="scss" scoped>
.condition-panel__condition {
  .conditions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .condition {
    text-align: center;
    width: calc(100% / 4 - 10px * (3 / 4));
    font-size: $fs-m;
    .value {
      background: $text-background;
      padding: 5px 0;
    }
  }

  .body-pain {
    margin-bottom: 10px;
    &__heading {
      font-size: $fs-m;
      font-weight: bold;
      padding-bottom: 5px;
    }
    &__text {
      font-size: $fs-m;
      background: $text-background;
      padding: 5px 10px;
      display: inline-block;

      &.detail {
        width: 100%;
      }
    }
  }
  
}
</style>